<template>
  <component class="feature-list" :is="component">
    <slot />
  </component>
</template>

<script>
export default {
  props: {
    component: {
      type: String,
      default: 'ul',
    },
  },

  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.feature-list {
  list-style: none;
  padding: 0;
  margin: 0.5rem 0;
}

ol.feature-list {
  counter-reset: feature-list-counter;

  li {
    counter-increment: feature-list-counter;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.25rem 0;

    &::before {
      background: var(--c-text-color);
      color: var(--c-bg-color);
      content: counter(feature-list-counter);
      font-size: 0.9em;
      height: 1.75em;
      width: 1.75em;
      border-radius: 50%;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
